import React, {useEffect, useRef, useState} from 'react';
import "./AwardDesktop.scss";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";
import HeaderDesktop from "../DesktopComponents/HeaderDesktop/HeaderDesktop";
import {getMallMerchant_api} from "../../Services/apis";
import DrShopHeader from "../../Components/DrShopHeader/DrShopHeader";
import {FestivalData} from "../Festival/FestivalServices";
import {useHistory} from "react-router";
import {useLocation} from "react-router-dom";
import Swiper from "swiper";
import {ConvertTMonthName} from "../../Services";
import moment from "moment-jalaali";
import {FestivalDetailData} from "../FestivalDetail/FestivalDetailServices";
import {TextBreak} from "../../Components";
import {LotteryCard} from "../FestivalDetail/LotteryCard";
import {Col, Modal, Row, Spin} from "antd";
import Awards from "../Awards/Awards";
import {AwardsReceiveApi, getAwardConditionsApi, getAwardItemsApi, getAwardsApi} from "../Awards/AwardsService";
import toaster from "toasted-notes";
import QRCode from "react-qr-code";
import {StoreDataMallAccount} from "../Store/StoreServices";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {useResp} from "../../hooks";

//swiper
import 'swiper/swiper-bundle.min.css'
import 'antd/dist/antd.css';
import {UserCouponDataPage} from "../StoreDetail/StoreDetailServices";

const imageParams = {
    slidesPerView: 'auto',
    spaceBetween: 8,
    rtl:true,
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

let awardPage = 1;
let itemsPage = 1;
let activeT = "shop";




export default function AwardDesktop(){


    const history = useHistory()
    const [cats,set_cats] = useState([
            {name:"همه",status:"active"},
            {name:"مد و پوشاک"},
            {name:"زیبایی و بهداشت"},
            {name:"لوازم خانگی"},
            {name:"لوازم ورزشی"},
        ]
    )

    const [sliders,set_sliders] = useState([
            // {image:"/other/award/slid1.png"},
            // {image:"/other/award/slid2.png"},
            // {image:"/other/award/slid1.png"},
            // {image:"/other/award/slid2.png"},
            // {image:"/other/award/slid2.png"},
            // {image:"/other/award/slid3.png"},
            // {image:"/other/award/slid4.png"}
        ]
    )



    const AwardCard = ({item,merchant})=>{


        //scroll detection


        //-----------------------------

        const [modalz, set_modalz] = useState(false);
        const [finalModalz, set_finalModalz] = useState(false);

        const showModal = () => {
            set_modalz(true);
        };

        const handleOk = () => {
            set_modalz(false);
        };

        const handleCancel = () => {
            set_modalz(false);
        };



        const handleFinalOk = () => {
            set_finalModalz(false);
        };

        const handleFinalCancel = () => {
            set_finalModalz(false);
        };

        const [instruction,set_instruction] = useState({})


        const awardBuy = async () => {
            set_spinModal(true)
            try{
                const res = await AwardsReceiveApi(merchant.uid,item.uid)
                set_earnedCode(res.data.code)
                set_modalz(false)
                set_finalModalz(true)
                set_spinModal(false)
            }catch (e) {
                switch (e.response.data.code) {
                    case 'you_dont_have_enough_scores_to_use_this_award':
                        toaster.notify(({ onClose }) => (<Error   message={"شما امتیاز کافی برای خرید این جایزه را ندارید"}/>),{duration: 2000});
                        break;
                    case 'there_is_no_available_award':
                        toaster.notify(({ onClose }) => (<Error   message={"در حال حاضر امکان خرید نمی باشد"}/>),{duration: 2000});
                        break;
                    default:
                        toaster.notify(({ onClose }) => (<Error   message={"مشکلی پیش آمده است"}/>),{duration: 2000});

                }
                set_spinModal(false)
            }
        };

        const awardConditions = async () => {
            set_spinCard(true)
            try{
                const res = await getAwardConditionsApi(merchant.uid,item.uid)
                set_modalz(true)
                set_spinCard(false)
                set_instruction(res.data)
            }catch (e) {
                set_spinCard(false)
                console.log(e)
            }
        };

        const [spinCard,set_spinCard] = useState(false)
        const [spinModal,set_spinModal] = useState(false)
        const [earnedCode,set_earnedCode] = useState(false)



        return(
            <div className="awards-item" >

                <Modal footer={null}  visible={finalModalz} onOk={handleFinalOk} onCancel={handleFinalCancel}>
                    <div className="award-result-modal">
                        <div className="award-result-modal-logo">
                            <img src="/other/award_logo.jpg" alt=""/>
                        </div>

                        <div className="award-result-modal-title">
                            <span>تبریک ,  جایزه خدمت شما</span>
                        </div>

                        <div className="award-result-modal-message">
                            <p>جوایز از همین قسمت قابل دیدن و استفاده اند و نیازی به یادداشت کد تخفیف نیست . </p>
                        </div>


                        {/*<div className="award-result-modal-list">*/}
                        {/*    <div className="award-result-modal-item">*/}
                        {/*        <span style={{*/}
                        {/*            color:"red"*/}
                        {/*        }}>{item.date}</span>*/}
                        {/*        <span>مدت زمان اعتبار</span>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="award-result-modal-qr">

                            <div className="award-result-modal-qr-row">
                                <span className="award-result-modal-qr-code">{earnedCode}</span>
                                <span>کد جایزه</span>
                            </div>

                            <div className="award-result-modal-qrcode">
                                <QRCode size={128} value={earnedCode} />
                            </div>

                        </div>

                    </div>
                </Modal>

                <Modal footer={null}  visible={modalz} onOk={handleOk} onCancel={handleCancel}>
                    <Spin spinning={spinModal}>
                        <div className="access-modal">
                            <div className="award-modal-header">
                                <div className="award-modal-header-row">
                                    <div className="award-modal-header-img">
                                        <img src={item.image} alt=""/>
                                    </div>
                                </div>
                                <div className="award-modal-header-row">
                                    <div className="award-modal-header-title">
                                        <span>{item.title}</span>
                                    </div>
                                </div>
                                <div className="award-modal-header-row">
                                    <span className="award-modal-header-point">{item.required_points} امتیاز مورد نیاز</span>
                                </div>
                            </div>

                            <div className="award-modal-body">

                                <div className="award-modal-body-item">
                                    <div className="award-modal-item-title">
                                        <span>توضیحات</span>
                                    </div>
                                    <div className="award-modal-item-text">
                                        <p>{instruction.description}</p>
                                    </div>
                                </div>

                                <div className="award-modal-body-item">
                                    <div className="award-modal-item-title">
                                        <span>شرایط استفاده</span>
                                    </div>
                                    <div className="award-modal-item-text">
                                        <p>{instruction.usage_condition}</p>
                                    </div>
                                </div>

                                <div className="award-modal-body-item">
                                    <div className="award-modal-item-title">
                                        <span>نحوه استفاده</span>
                                    </div>
                                    <div className="award-modal-item-text">
                                        <p>{instruction.instruction}</p>
                                    </div>
                                </div>

                                {/*<div className="award-modal-body-item">*/}
                                {/*    <div className="award-modal-item-title">*/}
                                {/*        <span>لازم به ذکر است </span>*/}
                                {/*    </div>*/}
                                {/*    <div className="award-modal-item-text">*/}
                                {/*        <p>با دریافت جایزه امتیاز کسر شده قابل بازگشت نیست</p>*/}
                                {/*        <p>برای اطلاعات بیشتر می توانید با قسمت چت فروشگاه تماس بگیرید</p>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                <div className="award-float-btn" onClick={()=>{
                                    awardBuy()
                                }}>
                                    <span>دریافت جایزه</span>
                                </div>

                            </div>

                        </div>
                    </Spin>

                </Modal>
                <Spin spinning={spinCard}>
                    <div onClick={()=>{
                        awardConditions()
                    }}>
                        <div className="awards-item-header">
                            <img src={item.image} alt=""/>
                        </div>
                        <div className="awards-item-body">
                            <div className="awards-item-text">
                                <div className="lottery-badg">{item.award_type==="campaign_lottery_point"?<span>امتیاز قرعه کشی : {item.related_campaign.title}</span>:null}</div>
                                <span>{item.title}</span>
                            </div>
                            <div className="awards-item-date">
                                {/*<span>{item.date}</span>*/}
                            </div>
                        </div>
                        <div className="awards-item-footer">
                            <div className="award-rotated-half-up-circle"></div>
                            <div className="award-rotated-half-down-circle"></div>
                            <span>جزییات</span>
                            <span style={{direction:"rtl"}}> {item.required_points} امتیاز </span>
                        </div>
                    </div>
                </Spin>
            </div>
        )
    }

    const [merchantMall,set_merchantMall] = useState({})

    const [data,set_data] = useState([])
    const [items,set_items] = useState([])
    const [mall,set_mall] = useState({})




    useEffect(()=>{
        getMall()
        getAwards()
        getItems()
    },[])

    const getMall = ()=>{
        let mall = localStorage.getItem('mall');
        if(mall){
            let parsedMall = JSON.parse(mall);
            set_mall(parsedMall)
        }
    }

    const getAwards = async ()=>{
        try{
            const merchantUid  = await StoreDataMallAccount();
            set_merchantMall(merchantUid.data)
            const res = await getAwardsApi(merchantUid.data.uid,awardPage)
            set_data(res.data.results)
        }catch (e) {
            console.log(e)
        }
    }

    const getAwardsPage = async () => {
        try {
            const merchantUid  = await StoreDataMallAccount();
            set_merchantMall(merchantUid.data)
            const res = await getAwardsApi(merchantUid.data.uid,awardPage)
            set_data((list)=>[...list,...res.data.results]);
        } catch (e) {
            console.log(e)
        }
    }


    const getItems = async ()=>{
        try{
            const res  = await getAwardItemsApi();
            set_items(res.data.results)
        }catch (e) {
            console.log(e)
        }
    }

    const getItemsPage = async () => {
        try {
            const res = await getAwardItemsApi(itemsPage)
            set_items((list)=>[...list,...res.data.results]);
        } catch (e) {
            console.log(e)
        }
    }

    const [activeTab,set_activeTab] = useState("shop")

    const handleChangeTab = (tab)=>{
        set_activeTab(tab);
        activeT = tab;
        awardPage = 1;
        itemsPage = 1;
        getAwards()
        getItems()
    }

    const tabTitle =()=>{
        let result = ""
        switch (activeTab) {
            case "shop":
                result = ` جوایز ${mall.name}`
                break;
            case "buy":
                result = "لیست کدهای خریداری شده"
                break;
            case "history":
                result = "تاریخچه کدهای خریداری شده"
                break;
            default:
                result = ` جوایز ${mall.name}`
        }
        return result
    }

    // const [awardSelected,set_awardSelected] = useState({})
    //
    // const handleAwardClick = (item)=>{
    //     console.log("sdasdsadads",item)
    //     set_awardSelected(item)
    // }


    //items assets --------------------------------------------------------------------

    // const ItemsCard = ({item})=>{
    //
    //     return(
    //         <div className="awards-item" >
    //                 <div>
    //                     <div className="awards-item-header">
    //                         <img src={item.award.image} alt=""/>
    //                         {/*<span>تماشای آنلاین فیلم و سریال</span>*/}
    //                     </div>
    //                     <div className="awards-item-body">
    //                         <div className="awards-item-text">
    //                             <span>{item.award.title}</span>
    //                         </div>
    //                         <div className="awards-item-date">
    //                             {/*<span>{item.date}</span>*/}
    //                         </div>
    //                     </div>
    //                     <div className="awards-item-footer">
    //                         <div className="award-rotated-half-up-circle"></div>
    //                         <div className="award-rotated-half-down-circle"></div>
    //                         <span>{item.code}</span>
    //                         <span>کد</span>
    //                     </div>
    //                 </div>
    //         </div>
    //     )
    // }



    const ItemsCard = ({item,merchant})=>{


        //scroll detection


        //-----------------------------

        const [modalz, set_modalz] = useState(false);
        const [finalModalz, set_finalModalz] = useState(false);

        const showModal = () => {
            set_modalz(true);
        };

        const handleOk = () => {
            set_modalz(false);
        };

        const handleCancel = () => {
            set_modalz(false);
        };



        const handleFinalOk = () => {
            set_finalModalz(false);
        };

        const handleFinalCancel = () => {
            set_finalModalz(false);
        };

        const [instruction,set_instruction] = useState({})


        const awardConditions = async () => {
            set_spinCard(true)
            try{
                const res = await getAwardConditionsApi(merchant.uid,item.award.uid)
                set_modalz(true)
                set_spinCard(false)
                set_instruction(res.data)
            }catch (e) {
                set_spinCard(false)
                console.log(e)
            }
        };

        const [spinCard,set_spinCard] = useState(false)
        const [spinModal,set_spinModal] = useState(false)
        const [earnedCode,set_earnedCode] = useState(false)



        return(
            <div className="awards-item" >


                <Modal footer={null}  visible={modalz} onOk={handleOk} onCancel={handleCancel}>
                    <Spin spinning={spinModal}>
                        <div className="access-modal">
                            <div className="award-modal-header">
                                <div className="award-modal-header-row">
                                    <div className="award-modal-header-img">
                                        <img src={item.award.image} alt=""/>
                                    </div>
                                </div>
                                <div className="award-modal-header-row">
                                    <div className="award-modal-header-title">
                                        <span>{item.award.title}</span>
                                    </div>
                                </div>
                                <div className="award-modal-header-row">
                                    <span className="award-modal-header-point">{item.award.required_points} امتیاز مورد نیاز</span>
                                </div>
                            </div>

                            <div className="award-modal-body">

                                <div className="award-modal-body-item">
                                    <div className="award-modal-item-title">
                                        <span>توضیحات</span>
                                    </div>
                                    <div className="award-modal-item-text">
                                        <p>{instruction.description}</p>
                                    </div>
                                </div>

                                <div className="award-modal-body-item">
                                    <div className="award-modal-item-title">
                                        <span>شرایط استفاده</span>
                                    </div>
                                    <div className="award-modal-item-text">
                                        <p>{instruction.usage_condition}</p>
                                    </div>
                                </div>

                                <div className="award-modal-body-item">
                                    <div className="award-modal-item-title">
                                        <span>نحوه استفاده</span>
                                    </div>
                                    <div className="award-modal-item-text">
                                        <p>{instruction.instruction}</p>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </Spin>
                </Modal>
                <Spin spinning={spinCard}>
                    <div onClick={()=>{
                        awardConditions()
                    }}>
                        <div className="awards-item-header">
                            <img src={item.award.image} alt=""/>
                            {/*<span>تماشای آنلاین فیلم و سریال</span>*/}
                        </div>
                        <div className="awards-item-body">
                            <div className="awards-item-text">
                                <div className="lottery-badg">{item.award.award_type==="campaign_lottery_point"?<span>امتیاز قرعه کشی : {item.award.related_campaign.title}</span>:null}</div>
                                <span>{item.award.title}</span>
                            </div>
                            <div className="awards-item-date">
                                {/*<span>{item.date}</span>*/}
                            </div>
                        </div>
                        <div className="awards-item-footer">
                            <div className="award-rotated-half-up-circle"></div>
                            <div className="award-rotated-half-down-circle"></div>
                            <span>{item.code}</span>
                            <span>کد</span>
                        </div>
                    </div>
                </Spin>
            </div>
        )
    }


    const handleScr = ()=>{
        const doc = document.documentElement;
        let calc = doc.scrollHeight -(doc.scrollTop + doc.clientHeight)
        if(calc === 0) {
            if(activeT==="shop"){
                awardPage = awardPage+1
                getAwardsPage()
            }
            if(activeT==="buy"){
                itemsPage = itemsPage+1
                getItemsPage()
            }
        }
    }

    useEffect(()=>{
        //handle scroll arrived to Top
        window.currentPage = 1;
        window.addEventListener('scroll',handleScr);
        return () => {
            window.removeEventListener('scroll', handleScr); // Remove Scroll Event Listener
        };
    },[])


    const { height, width,mobileWidth } = useWindowDimensions();

    const resp = useResp();
    return(
        <div>
            <DrShopHeader home={true}/>


            <Row gutter={[16,4]} justify="center"  className="component-row">
                <Col xs={{ span: 13 }} sm={{ span: 13 }} md={{ span: 13 }} lg={{ span: 13}} >

                    <div className="awards-container">

                        {/*Header*/}
                        {/*<div className="storeDetail-header" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>*/}
                        {/*    <h5>{` جوایز ${mall.name}`}</h5>*/}

                        {/*    <i onClick={()=>{*/}
                        {/*        history.goBack();*/}
                        {/*    }}*/}
                        {/*       className="fa fa-arrow-left"></i>*/}
                        {/*</div>*/}


                        <div className="awards-body">

                            <div className="awards-tabs">
                                <div className={activeTab==="buy"?"awards-tabs-item awards-tabs-item-active":"awards-tabs-item"}
                                     onClick={()=>handleChangeTab("buy")}
                                >
                                    <span>جوایز خریداری شده</span>
                                </div>
                                {/*<div className={activeTab==="history"?"awards-tabs-item awards-tabs-item-active":"awards-tabs-item"}*/}
                                {/*     onClick={()=>handleChangeTab("history")}*/}
                                {/*>*/}
                                {/*    <span>تاریخچه</span>*/}
                                {/*</div>*/}
                                <div className={activeTab==="shop"?"awards-tabs-item awards-tabs-item-active":"awards-tabs-item"}
                                     onClick={()=>handleChangeTab("shop")}
                                >
                                    <span>{` جوایز ${mall.name}`}</span>
                                </div>
                            </div>
                            {/*<div className="awards-categories">*/}
                            {/*    <SwiperId {...imageParams}>*/}
                            {/*        {cats.map(cat=>{*/}
                            {/*            return(*/}
                            {/*                <div className={cat.status?"awards-categories-slid-active":"awards-categories-slid"}>*/}
                            {/*                    <span>{cat.name}</span>*/}
                            {/*                </div>*/}
                            {/*            )*/}
                            {/*        })}*/}
                            {/*        <div className="awards-categories-slid-pre"></div>*/}
                            {/*        <div className="awards-categories-slid-pre"></div>*/}
                            {/*    </SwiperId>*/}
                            {/*</div>*/}


                            {/*<div className="awards-Popular">*/}
                            {/*    <div className="awards-title">*/}
                            {/*        <span>  جوایز استفاده شده </span>*/}
                            {/*    </div>*/}
                            {/*    <div className="awards-slider">*/}
                            {/*        <SwiperId {...imageParams}>*/}
                            {/*            {sliders.map(slide=>{*/}
                            {/*                return(*/}
                            {/*                    <div className="awards-popular-slid">*/}
                            {/*                        <img src={slide.image} alt=""/>*/}
                            {/*                    </div>*/}
                            {/*                )*/}
                            {/*            })}*/}
                            {/*            <div className="awards-popular-slid"></div>*/}
                            {/*        </SwiperId>*/}
                            {/*    </div>*/}
                            {/*</div>*/}


                            <div className="awards-title">
                       <span>
                           {tabTitle()}
                   </span>
                            </div>

                            {activeTab==="shop"?<div className="awards-items-sec">
                                <div className="awards-items-list">
                                    {data.map(d=>{
                                        return(
                                            <AwardCard item={d} merchant={merchantMall} />
                                        )
                                    })}

                                </div>
                            </div>:null}


                            {activeTab==="buy"?<div className="awards-items-sec">
                                <div className="awards-items-list">
                                    {items.map(d=>{
                                        return(
                                            <ItemsCard item={d} merchant={merchantMall} />
                                        )
                                    })}

                                </div>
                            </div>:null}



                        </div>


                    </div>
                </Col>
            </Row>

            <br/><br/>
            <FooterDesktop/>
        </div>
    )
}
